import React from 'react';
import { Button, Modal } from 'semantic-ui-react';

const RemovalConfirmation = (props) => {
  return (
    <Modal open={props.open} onClose={() => props.setOpen(false)}>
      <Modal.Header>Remove Patient Encounter</Modal.Header>
      <Modal.Content>
        <p>
          Are you sure you want to remove encounter{' '}
          <span style={{ fontWeight: 'bold' }}>{props.patientName}</span>?
        </p>
        <p>It will be permanently removed from the Work Queue.</p>
      </Modal.Content>
      <Modal.Actions>
        <Button
          id='remove-encounter-cancel-button'
          color='red'
          onClick={() => {
            props.setOpen(false);
          }}
        >
          Cancel
        </Button>
        <Button
          id='remove-encounter-delete-button'
          color='black'
          onClick={async () => {
            props.handleTeammateChange(
              props.dropdownEvent?.event,
              props.dropdownEvent?.data
            );
            props.handleQueueUpdate();
            props.setOpen(false);
          }}
        >
          Remove
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default RemovalConfirmation;
